
import authConstants from './authConstants';
import getEssentialsUrl from '../api/config';
import sessionApi from '../api/ic/sessionApi';


const { FR_UI_PORT, DEV_PORTAL_PORT, ACTIVITY_SYNC_KEY, AUTH_STATE_KEY } = authConstants;

export const isLocal = () => window.location.hostname === 'localhost';

const getLoginUrl = () => {
  if (isLocal()) return `http://localhost:${FR_UI_PORT}/#/login`;
  return `${getEssentialsUrl()}/static/public/onb/onboarding-ui-apps/availity-fr-ui/#/login`;
};

const getLogoutUrl = () => {
  if (isLocal()) return `http://localhost:${FR_UI_PORT}/signout`;
  return `${getEssentialsUrl()}/signout`;
};

const getGotoUrl = () => {
  if (isLocal()) return encodeURIComponent(`http://localhost:${DEV_PORTAL_PORT}/#/`);
  return encodeURIComponent(`${window.location.origin}/#/`);
};

export const LOGIN_URL = getLoginUrl();
export const LOGOUT_URL = getLogoutUrl();
export const GOTO_URL = getGotoUrl();

/**
 * logout — signals other tabs and redirects to fr-ui logout
 * for session cleanup.
 */
export const redirectToLogout = (sessionStore: { setIsAuthenticated: (value: boolean | null) => void }): void => {
  localStorage.setItem(AUTH_STATE_KEY, 'logged-out');
  sessionStore.setIsAuthenticated(null);
  localStorage.removeItem(ACTIVITY_SYNC_KEY);
  window.location.href = LOGOUT_URL;
};

export const redirectToLogin = (): void => {
  try {
    const isLocalHost = isLocal();
    const safeGotoUrl = isLocalHost
      ? encodeURIComponent(`http://localhost:${DEV_PORTAL_PORT}/#/`)
      : encodeURIComponent(`${window.location.origin}/#/`);
    window.location.href = `${LOGIN_URL}?goto=${safeGotoUrl}`;
  } catch {
    // silently fail
  }
};

export const loginOrRedirect = async (): Promise<void> => {
  
    // For Thales, check session via SessionRefreshServlet
    try {
      const response = await sessionApi.refreshSession();
      if (response?.status === 200 && !(response as { data?: unknown }).data) {
        // 200 with empty body — already logged in
        window.location.reload();
        return;
      }
    } catch {
      // 401 or error — not logged in, redirect to login
    }
    redirectToLogin();
};

